import axios from "axios";
import { dsvFormat, group } from "d3";
import * as IDS from "@/utils/ids";
import { getNumber } from "@/utils/helpers";

const baseURL = window.data_vis_uri || "";

const api = axios.create({
  baseURL: baseURL + "data",
});

var csvParse = dsvFormat(",");

let global = { boys: null, girls: null };
let fetchedGlobal = { boys: false, girls: false };

let linkedRisks = { boys: {}, girls: {} };
let fetchedLinkedRisks = { boys: {}, girls: {} };

let prevalence = { boys: {}, girls: {} };
let fetchedPrevalence = { boys: {}, girls: {} };

let map = {};
let fetchedMap = {};

let policy = null;
let fetchedPolicy = false;

let lrTexts = { boys: null, girls: null };
let fetchedLRTexts = { boys: false, girls: false };

let prevalenceTexts = { boys: null, girls: null };
let fetchedPrevalenceTexts = { boys: false, girls: false };

let policyTexts = null;
let policyCitations = null;

export default {
  async getGlobalData(dataset = "girls") {
    if (!fetchedGlobal[dataset]) {
      try {
        const csv = (await api(`/${dataset}/prevalence/all_nat_prev_data.csv`))
          .data;

        fetchedGlobal[dataset] = true;

        global[dataset] = process(csvParse.parse(csv));
      } catch (err) {
        console.log(err);
      }
    }
    return global[dataset];
  },
  async getPopulations(dataset = "girls") {
    if (!fetchedGlobal) {
      try {
        await this.getGlobalData(dataset);
      } catch (err) {
        console.log(err);
      }
    }
    return global.map((e) => ({
      id: e.iso3,
      total: getNumber(e[IDS.POPULATION]),
    }));
  },
  async getLinkedRisks(iso, dataset = "girls") {
    if (!fetchedLinkedRisks[dataset][iso]) {
      try {
        const csv = (
          await api(`/${dataset}/linkedrisks/${iso}_LinkedRisks.csv`)
        ).data;

        fetchedLinkedRisks[dataset][iso] = true;

        linkedRisks[dataset][iso] = process(csvParse.parse(csv));
      } catch (err) {
        console.log(err);
      }
    }
    return linkedRisks[dataset][iso];
  },
  async getPrevalence(iso, dataset = "girls") {
    if (!fetchedPrevalence[dataset][iso]) {
      try {
        const csv = (
          await api(`/${dataset}/prevalence/${iso}_subnat_prev_data.csv`)
        ).data;

        fetchedPrevalence[dataset][iso] = true;

        prevalence[dataset][iso] = process(csvParse.parse(csv));
      } catch (err) {
        console.log(err);
      }
    }
    return prevalence[dataset][iso];
  },
  async getMap(iso) {
    if (!fetchedMap[iso]) {
      try {
        const json = (await api(`/maps/${iso}.json`)).data;

        fetchedMap[iso] = true;

        map[iso] = json;
      } catch (err) {
        console.log(err);
      }
    }
    return map[iso];
  },
  async getPolicyData() {
    if (!fetchedPolicy) {
      try {
        const csv = (await api("/policies.csv")).data;

        fetchedPolicy = true;

        // var csvParse = dsvFormat(",");

        policy = process(csvParse.parse(csv));
      } catch (err) {
        console.log(err);
      }
    }
    return policy;
  },
  async getLinkedRisksTexts(dataset = "girls") {
    if (!fetchedLRTexts[dataset]) {
      try {
        const csv = (await api(`/${dataset}/a3_web_text_lr.csv`)).data;

        fetchedLRTexts[dataset] = true;

        lrTexts[dataset] = processLrTexts(csvParse.parse(csv));
      } catch (err) {
        console.log(err);
      }
    }
    return lrTexts[dataset];
  },
  async getPrevalenceTexts(iso, dataset = "girls") {
    try {
      const csv = (await api(`/${dataset}/a3_web_text_prev.csv`)).data;

      fetchedPrevalenceTexts[dataset] = true;

      prevalenceTexts[dataset] = processPrevalenceTexts(csvParse.parse(csv));
    } catch (err) {
      console.log(err);
    }

    return prevalenceTexts[dataset].get(iso);
  },
  async getPolicyTexts(filename) {
    try {
      const json = (await api(filename)).data;
      policyTexts = json;
    } catch (err) {
      console.log(err);
    }
    return policyTexts;
  },
  async getPolicyCitationTexts(filename) {
    try {
      const json = (await api(filename)).data;

      policyCitations = json;
    } catch (err) {
      console.log(err);
    }
    return policyCitations;
  },
};

function process(data) {
  return data;
}

function processLrTexts(data) {
  const result = {};
  data.forEach((country) => {
    result[country[IDS.COUNTRY]] = country[IDS.TEXT];
  });
  return result;
}

function processPrevalenceTexts(data) {
  const groups = group(
    data,
    (e) => e[IDS.COUNTRY],
    (e) => e[IDS.INDICATOR]
  );

  return groups;
}
